module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": _vm.type
    }
  }, [_c('div', {
    attrs: {
      "id": "loading-text"
    }
  }), _c('br'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "id": "pattern_div"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "spinning-cog",
    staticStyle: {
      "width": "100px",
      "height": "100px"
    },
    attrs: {
      "src": require("../../assets/mondoconnex-logo-icon@2x.png")
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "page_progress"
    }
  }, [_c('div', {
    attrs: {
      "id": "progress_bar"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d342bd7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/loading.vue
// module id = 204
// module chunks = 14